/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react';
import {toAbsoluteUrl} from '../../../helpers';
import styles from './HeaderUserMenu.module.scss';
import {useIntl} from 'react-intl';
import {useNativeAuth} from '../../../../app/modules/auth/native/NativeAuthProvider';

const HeaderUserMenu: FC = () => {
  const intl = useIntl();
  const {claims, logout: nativeLogout} = useNativeAuth();
  const displayName = claims?.name as string;
  const displayEmail = claims?.preferred_username as string;

  const handleLogout = () => {
    // Le client courant est conservé côté serveur d'une session à l'autre
    sessionStorage.setItem('client_typologie', '');
    // Réinitialise les popups « session » pour qu'ils se réaffichent à la prochaine connexion
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith('news_popup_'))
      .forEach((key) => sessionStorage.removeItem(key));
    nativeLogout();
  };

  return (
    <div
      className={`menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-3 fs-6 ${styles.dropdown}`}
      data-kt-menu="true"
    >
      <div className="menu-item px-3 d-md-none">
        <div className="menu-content d-flex align-items-center px-3">
          <div className="me-5">
            <img alt="Logo" src={toAbsoluteUrl('/media/avatars/icon-profile-02.png')} />
          </div>

          <div className="d-flex flex-column">
            <div className="fw-bolder d-flex align-items-center fs-5">{displayName}</div>
            <a href="#" className="fw-bold text-muted text-hover-primary fs-7">
              {displayEmail}
            </a>
          </div>
        </div>
      </div>
      <div className="separator my-2 d-md-none"></div>
      <div className="menu-item">
        <a
          onClick={handleLogout}
          className="menu-link px-6 py-1 rounded"
          style={{
            fontSize: '1rem',
            fontWeight: 500,
            color: '#1e1e1f',
            fontFamily: 'Inter',
          }}
        >
          <i
            className="bi bi-box-arrow-right me-3"
            style={{fontSize: '1.3rem', color: '#322f2f'}}
          ></i>
          {intl.formatMessage({id: 'HEADER.USER_MENU.LOGOUT'})}
        </a>
      </div>
    </div>
  );
};

export {HeaderUserMenu};
